/* eslint-disable @typescript-eslint/no-explicit-any */
import { Op } from 'contensis-delivery-api'

export const standard = (
  value: string,
  terms: string[],
  extraTerm: ((term: string) => any)[] = []
) =>
  Op.or(
    Op.contains('seoStandard.title', value).weight(9),
    Op.freeText('seoStandard.title', value, true, 'or').weight(8),
    Op.freeText('entryTitle', value, true, 'or').weight(8),

    Op.or(
      Op.freeText('seoStandard.focusKeyphrase', value, true, 'or').weight(6),
      Op.freeText('description', value, true, 'or').weight(3),
      Op.freeText('seoStandard.description', value, true, 'or').weight(3),
      Op.freeText('seoStandard.keywords', value, true, 'or').weight(2),
      Op.freeText('searchContent', value, true, 'or').weight(1)
    ),

    Op.or(
      ...terms.flatMap(term => [
        Op.contains('seoStandard.title', term).weight(6),
        Op.freeText('seoStandard.title', value, true, 'or').weight(4),
        Op.freeText('seoStandard.focusKeyphrase', term, true, 'or').weight(3),
        Op.freeText('description', term, true, 'or').weight(2),
        Op.freeText('seoStandard.description', term, true, 'or').weight(2),
        Op.freeText('seoStandard.keywords', term, true, 'or').weight(1),
        Op.freeText('searchContent', term, true, 'or').weight(1),
        ...extraTerm.map(fn => fn(term))
      ])
    )
  )

const stopWords = new Set([
  'a',
  'an',
  'and',
  'are',
  'as',
  'at',
  'be',
  'by',
  'for',
  'from',
  'has',
  'in',
  'is',
  'it',
  'of',
  'on',
  'or',
  'that',
  'the',
  'to',
  'was',
  'were',
  'with',
  'you',
  'your'
])

export const cleanTerms = (value: string) => {
  return Array.from(
    new Set( // Deduplicate
      value
        .toLowerCase()
        .split(/\s+/) // Split by whitespace
        .map(word => word.replace(/[^\w'-]/g, '')) // Remove punctuation
        .filter(
          term =>
            term.length > 1 && // Filter short words
            !stopWords.has(term) // Filter stop words
        )
    )
  )
}

export const FACULTY_PATTERN =
  '(faculty of science and engineering|faculty of health sciences|faculty of arts, cultures and education|faculty of business, law and politics|science and engineering|health sciences|arts, social sciences and education|business, law and politics|science|engineering|health|arts|cultures|social|social sciences|education|business|law|politics)'

export function normaliseFaculty(faculty?: string) {
  if (!faculty) return undefined
  const map: Record<string, string> = {
    'faculty of science and engineering': 'faculty-of-science-and-engineering',
    'science and engineering': 'faculty-of-science-and-engineering',
    science: 'faculty-of-science-and-engineering',
    engineering: 'faculty-of-science-and-engineering',

    'faculty of health sciences': 'faculty-of-health-sciences',
    'health sciences': 'faculty-of-health-sciences',
    health: 'faculty-of-health-sciences',

    'faculty of arts, cultures and education':
      'faculty-of-arts-social-sciences-and-education',
    'arts, cultures and education':
      'faculty-of-arts-social-sciences-and-education',
    arts: 'faculty-of-arts-social-sciences-and-education',
    cultures: 'faculty-of-arts-social-sciences-and-education',
    social: 'faculty-of-arts-social-sciences-and-education',
    'social sciences': 'faculty-of-arts-social-sciences-and-education',
    education: 'faculty-of-arts-social-sciences-and-education',

    'faculty of business, law and politics': 'hull-university-business-school',
    'business, law and politics': 'hull-university-business-school',
    business: 'hull-university-business-school',
    law: 'hull-university-business-school',
    politics: 'hull-university-business-school'
  }
  return map[faculty.toLowerCase()] ?? undefined
}
